// extracted by mini-css-extract-plugin
export var auto = "_4d-1";
export var spinner = "_4d-0";